
Object.defineProperty(exports, "__esModule", { value: true });
var StorageType;
(function (StorageType) {
    StorageType["local"] = "local";
    StorageType["none"] = "none";
    StorageType["session"] = "session";
})(StorageType = exports.StorageType || (exports.StorageType = {}));
var AbstractSDKRequest = (function () {
    function AbstractSDKRequest() {
    }
    return AbstractSDKRequest;
}());
exports.AbstractSDKRequest = AbstractSDKRequest;
var AbstractStorage = (function () {
    function AbstractStorage() {
    }
    return AbstractStorage;
}());
exports.AbstractStorage = AbstractStorage;
